import { apiRequest } from '../api/client';
import { API_ENDPOINTS, withParams } from '../config/apis';

export type Announcement = {
  id: number;
  managerId: number;
  title: string;
  content: string;
  category: string;
  createdAt?: string;
  createdDate?: string;
  createdDateTime?: string;
  writer?: string;
  author?: string;
  managerName?: string;
};

export type AnnouncementPayload = {
  title: string;
  content: string;
  category: string;
};

type AnnouncementListResponse = {
  announcements: Announcement[];
};

export const announcementService = {
  list: () =>
    apiRequest<AnnouncementListResponse>(API_ENDPOINTS.announcementList).then(
      (response) => response.announcements
    ),

  detail: (announcementId: number) =>
    apiRequest<Announcement>(withParams(API_ENDPOINTS.announcementDetail, { announcementId })),

  create: (body: AnnouncementPayload) =>
    apiRequest<Announcement, AnnouncementPayload>(API_ENDPOINTS.announcementCreate, {
      body,
    }),

  update: (announcementId: number, body: Partial<AnnouncementPayload>) =>
    apiRequest<Announcement, Partial<AnnouncementPayload>>(
      withParams(API_ENDPOINTS.announcementUpdate, { announcementId }),
      { body }
    ),

  deleteMany: (announcementIds: number[]) =>
    apiRequest<Record<string, never>, { announcementIds: number[] }>(
      API_ENDPOINTS.announcementDelete,
      {
        body: { announcementIds },
      }
    ),
};
